<script lang="ts">
  import type { Maybe } from '$lib/types';

  export let currency = '$';
  /** price: Price as Float (Dollars + Cents; 123.00) */
  export let price: Maybe<number> | undefined = 0;
  /** figure: Price as Integer (in Cents; 12300) */
  export let figure: Maybe<number> | undefined = 0;
  export let roundUp = false;
  export let allowFree = false;

  export let type: 'credit' | 'debit' | null = null;
  export let suffix: Maybe<string> = null;
  export let showCurrencyName = false;
  export let id = null;
  let className = '';
  export { className as class };
  export let primaryColor = 'text-ondark-primary';
  export let secondaryColor = 'text-ondark-secondary';
  export let textAlign = 'text-right';
  export let lineHeight = 'leading-none';
  export let tracking = 'tracking-0.01';
  export let fontWeight = 'font-medium';
  export let locale = 'en-US';
  export let short = false;

  const sep = (1.1).toLocaleString(locale)[1];
  let base = 0;
  $: {
    base = 0;
    if (price) {
      base = roundUp ? Math.ceil(price) : price;
    } else if (figure) {
      base = roundUp ? Math.ceil(figure / 100) : figure / 100;
    }
  }
  $: [whole, decimal = 0] = base
    .toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    .split(sep);

  $: showDecimal = !roundUp && (!short || (short && decimal !== '00'));
</script>

{#if figure > 0 || price > 0 || !allowFree}
  <strong {id} class="{textAlign} {fontWeight} {tracking} {lineHeight} {className}">
    {#if type === 'debit' || type === 'credit'}
      <span class={primaryColor}>{type === 'debit' ? '-' : '+'}</span>
    {/if}
    <span class={primaryColor}>{currency}</span><!--
  --><span class={primaryColor}>{whole}</span
    ><!--
  -->{#if showDecimal}<!--
    --><span class={primaryColor}>{sep}{decimal}</span><!--
  -->{/if}
    {#if showCurrencyName}
      <span class={secondaryColor}>USD</span>
    {/if}
    {#if suffix}
      <span class={secondaryColor}>{suffix}</span>
    {/if}
  </strong>
{:else}
  <strong {id} class="{textAlign} {fontWeight} {tracking} {primaryColor} {lineHeight} {className}">Free</strong>
{/if}
